import React from "react";
import OptionsList from "../OptionsList/OptionsList";
import KYCQuestion from "./KYCQuestion";

export default class OriginOfDeposits extends KYCQuestion
{
	state = {
		fields: {
			checkbox_customer_kyc_deposit: {
				options: [
					{
						label: "Svensk bank/institut",
						value: "yes",
						name: "checkbox_customer_kyc_deposit_swedish_bank",
						checked: false
					},
					{
						label: "Utländsk bank/institut",
						value: "yes",
						name: "checkbox_customer_kyc_deposit_foreign_bank",
						checked: false
					},
					{
						label: "Svenskt försäkringsbolag",
						value: "yes",
						name: "checkbox_customer_kyc_deposit_swedish_insurance",
						checked: false
					},
					{
						label: "Utländskt försäkringsbolag",
						value: "yes",
						name: "checkbox_customer_kyc_deposit_foreign_insurance",
						checked: false
					},
					{
						label: "Pension",
						value: "yes",
						name: "checkbox_customer_kyc_deposit_pension",
						checked: false
					},
					{
						label: "Från min arbetsgivare",
						value: "yes",
						name: "checkbox_customer_kyc_deposit_employer",
						checked: false
					}
				]
			}
		}
	};

	constructor(props, context)
	{
		super(props, context);
		this.fieldName = "checkbox_customer_kyc_deposit";
	}

	render()
	{
		return (
			<React.Fragment>
				<OptionsList
					style={{marginTop: "35px"}}
					type="radio"
					name="checkbox_customer_kyc_deposit"
					description="Från vilken bank/institut kommer du generellt göra överföringar?"
					orientation="vertical"
					onChange={this._onOptionsListChange}
					options={this.state.fields.checkbox_customer_kyc_deposit.options}
				/>
			</React.Fragment>
		);
	}
}


// WEBPACK FOOTER //
// ./src/routes/Cob/components/KYC/OriginOfDeposits.js